import React from "react";
import MuiIconButton from "@mui/material/IconButton";
import MuiMenu from "@mui/material/Menu";
import MuiMenuItem from "@mui/material/MenuItem";
import MuiIconAccountCircle from "@mui/icons-material/AccountCircle";
import MuiIconLocalization from "@mui/icons-material/Language";

// Source
import * as HelperSrc from "../HelperSrc";
import ControllerHeader from "../controller/Header";
import ControllerLocalization from "../controller/Localization";

let isRendered = false;

const viewHeader: React.FC = () => {
    // Variable
    const controllerHeader = new ControllerHeader(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerHeader.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <div className="view_header">
                <div className="menu">
                    <MuiIconButton data-at_id="menu_user" name="menu_button" onClick={controllerHeader.clickOpenMenu}>
                        <MuiIconAccountCircle />
                    </MuiIconButton>
                    <MuiMenu
                        anchorEl={controllerHeader.getElementMenuButton}
                        open={controllerHeader.getIsMenuOpen}
                        onClose={controllerHeader.clickCloseMenu}
                    >
                        <MuiMenuItem
                            data-at_id="menu_profile"
                            onClick={() => {
                                if (controllerHeader.getStorageRoute) {
                                    HelperSrc.routerHistoryPush(controllerHeader.getStorageRoute.my_profile.path);
                                }
                            }}
                        >
                            <p>{controllerLocalization.getStorageMain.profile}</p>
                        </MuiMenuItem>
                        <MuiMenuItem
                            data-at_id="menu_logout"
                            onClick={() => {
                                if (controllerHeader.getStorageRoute) {
                                    HelperSrc.routerHistoryPush(controllerHeader.getStorageRoute.logout.path);
                                }
                            }}
                        >
                            <p>{controllerLocalization.getStorageMain.logout}</p>
                        </MuiMenuItem>
                    </MuiMenu>
                    <MuiIconButton data-at_id="menu_locale" name="locale_button" onClick={controllerLocalization.clickOpenLocalization}>
                        <MuiIconLocalization />
                    </MuiIconButton>
                    <MuiMenu
                        anchorEl={controllerLocalization.getElementMenuButton}
                        open={controllerLocalization.getIsLocalizationOpen}
                        onClose={controllerLocalization.closeLocalization}
                    >
                        <MuiMenuItem
                            data-at_id="menu_locale_ja_jp"
                            onClick={() => {
                                controllerLocalization.clickChange("ja", "jp");
                            }}
                        >
                            <p>{controllerLocalization.getStorageMain.japanese}</p>
                        </MuiMenuItem>
                        <MuiMenuItem
                            data-at_id="menu_locale_en_us"
                            onClick={() => {
                                controllerLocalization.clickChange("en", "us");
                            }}
                        >
                            <p>{controllerLocalization.getStorageMain.english}</p>
                        </MuiMenuItem>
                    </MuiMenu>
                </div>
            </div>
        );
    } else {
        return <></>;
    }
};

export default viewHeader;
